import React, { useEffect, useState } from "react";
import DayPlanningListing from "./DayPlanningListing";
import AddDaysFormWrapper from "../AddDays/AddDaysFormWrapper";
import { useGetAllPlansQuery } from "src/services/CourseServices";
import { useGetPlanDurationsQuery } from "src/services/CourseServices";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const DayPlanningListingWrapper = () => {
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);
  const [plansData, setPlansData] = useState<any>();
  const [planId, setPlanId] = useState("");
  const { courseId } = useParams()
  const [daysData, setDaysData] = useState<any>([])
  const [searchValue, setSearchValue] = useState('')


  const {
    data: allPlans,
    isLoading: allPlansLoading,
    isFetching: allPlansFetching,
  } = useGetAllPlansQuery({
    limit: 10,
    searchValue: searchValue,
    params: ["planName", "noOfDays", "courseId"],
    page: 1,
    filterBy: [{ fieldName: "courseId", value: courseId }],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  },);

  useEffect(() => {
    setPlanId(allPlans?.data?.[0]?._id);
  }, [allPlansFetching, allPlansLoading, allPlans]);



  const {
    data: durationData,
    isLoading: durationDataIsLoading,
    isFetching: durationDataIsFecthing,
  } = useGetPlanDurationsQuery(
    {
      limit: 10,
      searchValue: "",
      params: ["planName", "noOfDays", "courseId"],
      page: 1,
      filterBy: [{ fieldName: "_id", value: planId }],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: true,
    },
    { skip: !planId }
  );

  useEffect(() => {
    setPlansData(allPlans?.data);
  }, [allPlansLoading, allPlansFetching, allPlans]);

  useEffect(() => {
    setDaysData(durationData?.data?.[0])
  }, [durationDataIsLoading, durationDataIsFecthing, durationData])

  return (
    <>
      <div>
        {(allPlansLoading || allPlansFetching) && (
          <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
            <CircularProgress />
          </div>
        )}
        <DayPlanningListing
          plansData={plansData}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          planId={planId}
          durationData={daysData}
          durationDataIsLoading={durationDataIsFecthing || durationDataIsLoading}
          setPlanId={setPlanId}
          onAddDay={() => {
            setIsOpenAddForm(true);
          }}
        />
      </div>
      {isOpenAddForm && (
        <AddDaysFormWrapper onClose={() => setIsOpenAddForm(false)} />
      )}
    </>
  );
};

export default DayPlanningListingWrapper;
